import React from 'react'
import {AccessibilityMode} from '../../accessibility-mode'
import {TicketDescription} from '../../ticket-description'
import {Tickets} from '../../tickets'
import s from './sidebar.scss'
import {SidebarProps} from './index'

export const Sidebar = ({
  showAccessibilityMode,
  onRemoveClick,
  onCheckoutClick,
  chooseSeatMode,
  chooseMultipleSeatsMode,
  placesInBasket,
  placesInBasketCount,
  setForcedPopover,
  descriptionPlace,
  showSeatDescription,
  selectSeatForDescription,
  setAccessibilityToast,
}: SidebarProps) => (
  <div className={s.sidebar}>
    <Tickets
      placesInBasketCount={placesInBasketCount}
      placesInBasket={placesInBasket}
      show={!showAccessibilityMode && !showSeatDescription}
      onRemoveClick={onRemoveClick}
      onCheckoutClick={onCheckoutClick}
      onTicketMoreInfoClick={selectSeatForDescription}
      chooseSeatMode={chooseSeatMode}
      chooseMultipleSeatsMode={chooseMultipleSeatsMode}
      setForcedPopover={setForcedPopover}
    />
    <AccessibilityMode setForcedPopover={setForcedPopover} setAccessibilityToast={setAccessibilityToast} />
    {!showAccessibilityMode ? (
      <TicketDescription
        place={descriptionPlace}
        show={showSeatDescription}
        onClose={() => selectSeatForDescription(null)}
      />
    ) : null}
  </div>
)
